import styled from 'styled-components';
import theme from 'theme/theme';
import Flex from '../Flex';

const Columns = styled(Flex)`
  margin:  0 -${theme.grid.gutter / 2}${theme.grid.unit};
  clear: both;
`;

export default Columns;
